<template>
  <div class="container">
    <!-- <nav-bar leftName="返回" rightName="保存" @leftClick="leftClick" @rightClick="rightClick"></nav-bar> -->
    <div class="item-container">
      <div class="menu-content">
        <menu-list name="工作时间" :subName="workSubname" @handleClick="showPicker('工作时间', workTime)"></menu-list>
        <menu-list name="休息时间" :subName="breakSubname" @handleClick="showPicker('休息时间', breakTime)"></menu-list>
      </div>
      <div class="tip">设置番茄工作法工作时间和休息时间后，在秒秒测日历硬件上开启番茄工作法。</div>
      <button class="btn-block btn-save" @click="rightClick">保存</button>
    </div>
    <setting-internet v-if="showTip" @next="nextUpdate" @now="nowUpdate"></setting-internet>
    <ttip-select v-if="showSelectTip" @cancel="cancel" @sure="sure"></ttip-select>
  </div>
</template>
<script>
import SwitchList from '../../components/SwitchList/SwitchList.vue'
import NavBar from '../../components/NavBar/NavBar.vue'
import MenuList from '../../components/MenuList/MenuList.vue'
import Common from '../../assets/js/common.js'
import SettingInternet from '../../components/SettingInternet/SettingInternet.vue'
import TtipSelect from '../../components/TtipSelect/TtipSelect.vue'
import {mapState, mapMutations} from 'vuex'
import axios from 'axios'
var api = process.env.BASE_URL
var isLocal = Common.getEvn()
const column = Common.createArr(60)
export default {
  components: {
    SwitchList,
    NavBar,
    MenuList,
    SettingInternet,
    TtipSelect
  },
  data () {
    return {
      value: true,
      workTime: [25],
      breakTime: [5],
      currentType: 'work',
      workSubname: '25分钟',
      breakSubname: '5分钟',
      showTip: false,
      showSelectTip: false,
      userId: localStorage.getItem('max_userId'),
      deviceId: localStorage.getItem('max_device_id'),
      selectTimes: 0,
      quit: false
    }
  },
  computed: {
    ...mapState(['tomatoWarnInfo'])
  },
  destroyed () {
    this.cancelBack()
  },
  methods: {
    ...mapMutations(['TomatoWarnInfo']),
    pushHistory () {
      let state = {
        title: '',
        url: '/' + isLocal
      }
      window.history.pushState(state, state.title, state.url)
    },
    popstate () {
      if (this.showTip) {
        this.showTip = false
        this.$router.back()
      } else if (this.showSelectTip) {
        this.showSelectTip = false
        if (this.quit) {
          this.$router.back()
        } else {
          this.pushHistory()
        }
      } else {
        if (!this.quit) {
          if (this.isModify(true)) {
            this.showSelectTip = !this.showSelectTip
            this.pushHistory()
          }
        }
      }
    },
    verify () {
      var _this = this
      window.addEventListener('popstate', _this.popstate, false)
    },
    cancelBack () {
      var _this = this
      window.removeEventListener('popstate', _this.popstate)
    },
    addHistory () {
      if (this.isModify()) {
        if (this.selectTimes === 0) {
          this.pushHistory()
          this.selectTimes++
        }
      } else {
        if (this.selectTimes !== 0) {
          this.$router.back()
          this.selectTimes--
        }
      }
    },
    showPicker (title, selectedIndex) {
      if (title === '工作时间') {
        this.currentType = 'work'
      } else {
        this.currentType = 'break'
      }
      if (!this.picker) {
        this.picker = this.$createPicker({
          title,
          data: [column],
          onSelect: this.selectHandle,
          onCancel: this.cancelHandle,
          selectedIndex: [selectedIndex[0] - 1]
        })
      } else {
        this.picker.$updateProps({
          title,
          selectedIndex: [selectedIndex[0] - 1]
        })
      }
      this.picker.show()
    },
    selectHandle (date, selectedVal, selectedText) {
      if (this.currentType) {
        if (this.currentType === 'work') {
          this.workTime[0] = selectedVal[0] + 1
          this.workSubname = selectedVal[0] + 1 + '分钟'
          this.addHistory()
        } else {
          this.breakTime[0] = selectedVal[0] + 1
          this.breakSubname = selectedVal[0] + 1 + '分钟'
          this.addHistory()
        }
      }
    },
    cancelHandle () {},
    leftClick () {
      this.$router.back()
    },
    rightClick () {
      if (this.isModify()) {
        this.settingTomato()
      } else {
        this.$createToast({
          type: 'correct',
          txt: '您没有做任何修改',
          time: 2000
        }).show()
      }
    },
    cancel () {
      this.$router.back()
    },
    sure () {
      this.$router.back()
      this.quit = true
    },
    nextUpdate () {
      this.$router.back()
    },
    nowUpdate () {
      this.$router.back()
      this.quit = true
    },
    isModify () {
      if (!this.tomatoWarnInfo) return false
      if (parseInt(this.workTime[0]) !== parseInt(this.tomatoWarnInfo.tomato_work) || parseInt(this.breakTime[0]) !== parseInt(this.tomatoWarnInfo.tomato_rest)) return true
      return false
    },
    settingTomato () { // 设置番茄
      this.toast = this.$createToast({
        time: 0,
        txt: '保存中...',
        mask: true
      }).show()
      if (isLocal === 'local') {
        axios.post('/Calendar/api/device/set/device/tomato/', {
          'user_id': this.userId,
          'device_id': this.deviceId,
          'tomato_work': this.workTime[0],
          'tomato_rest': this.breakTime[0]
        })
        .then(this.settingTomatoSucc)
        .catch(this.settingTomatoErr)
      } else {
        axios.post(api + '/Calendar/api/device/set/device/tomato/', {
          'user_id': this.userId,
          'device_id': this.deviceId,
          'tomato_work': this.workTime[0],
          'tomato_rest': this.breakTime[0]
        })
        .then(this.settingTomatoSucc)
        .catch(this.settingTomatoErr)
      }
    },
    settingTomatoSucc (res) {
      this.toast.hide()
      var _res = res.data
      if (_res.result !== 0) {
        console.log(_res.result)
      } else {
        this.showTip = true
        this.TomatoWarnInfo(_res.tomato_info)
      }
    },
    settingTomatoErr (error) {
      this.toast.hide()
      console.log(error)
      this.toast = this.$createToast({
        txt: '设置失败',
        type: 'txt'
      }).show()
    }
  },
  created () {
    Common.setTitle('番茄工作法')
    this.verify()
    if (!this.tomatoWarnInfo) return
    if (this.tomatoWarnInfo.tomato_work) {
      this.workTime = [this.tomatoWarnInfo.tomato_work]
      this.workSubname = this.tomatoWarnInfo.tomato_work + '分钟'
    } else {
      this.workTime = [25]
      this.workSubname = '25分钟'
    }
    if (this.tomatoWarnInfo.tomato_rest) {
      this.breakTime = [this.tomatoWarnInfo.tomato_rest]
      this.breakSubname = this.tomatoWarnInfo.tomato_rest + '分钟'
    } else {
      this.breakTime = [5]
      this.breakSubname = '5分钟'
    }
  }
}
</script>
<style lang="stylus" scoped>
  .item-container
    height 100%
    overflow auto
    .menu-content
      padding 0 16px
      background #ffffff
    .tip
      font-size 10px
      line-height 30px
      text-align center
</style>


// WEBPACK FOOTER //
// src/pages/TomatoWork/TomatoWork.vue